/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DutyScheduleAssignmentChangeRequest } from './DutyScheduleAssignmentChangeRequest';
import {
    DutyScheduleAssignmentChangeRequestFromJSON,
    DutyScheduleAssignmentChangeRequestFromJSONTyped,
    DutyScheduleAssignmentChangeRequestToJSON,
    DutyScheduleAssignmentChangeRequestToJSONTyped,
} from './DutyScheduleAssignmentChangeRequest';

/**
 * 
 * @export
 * @interface SaveDutyScheduleAssignmentsRequest
 */
export interface SaveDutyScheduleAssignmentsRequest {
    /**
     * 
     * @type {Array<DutyScheduleAssignmentChangeRequest>}
     * @memberof SaveDutyScheduleAssignmentsRequest
     */
    changes: Array<DutyScheduleAssignmentChangeRequest>;
}

/**
 * Check if a given object implements the SaveDutyScheduleAssignmentsRequest interface.
 */
export function instanceOfSaveDutyScheduleAssignmentsRequest(value: object): value is SaveDutyScheduleAssignmentsRequest {
    if (!('changes' in value) || value['changes'] === undefined) return false;
    return true;
}

export function SaveDutyScheduleAssignmentsRequestFromJSON(json: any): SaveDutyScheduleAssignmentsRequest {
    return SaveDutyScheduleAssignmentsRequestFromJSONTyped(json, false);
}

export function SaveDutyScheduleAssignmentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveDutyScheduleAssignmentsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'changes': ((json['changes'] as Array<any>).map(DutyScheduleAssignmentChangeRequestFromJSON)),
    };
}

export function SaveDutyScheduleAssignmentsRequestToJSON(json: any): SaveDutyScheduleAssignmentsRequest {
    return SaveDutyScheduleAssignmentsRequestToJSONTyped(json, false);
}

export function SaveDutyScheduleAssignmentsRequestToJSONTyped(value?: SaveDutyScheduleAssignmentsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'changes': ((value['changes'] as Array<any>).map(DutyScheduleAssignmentChangeRequestToJSON)),
    };
}

